<template>
  <div class="_2zoVUbLx">
    <div class="_1SI39Ofv" v-if="show">
      <div class="_9-ZpLxb0">
        <img
          src="data:image/png;base64,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"
          alt="icon"
        />
        <div class="_3_qzGcRD"><span class="_1N8mCmac">-</span><span>B</span><span>O</span><span>B</span><span>.</span><span>C</span><span>O</span><span>M</span><span class="_1N8mCmac">-</span></div>
      </div>
    </div>
    <!-- <video src="/static/image/bg_batch-0ac1.mp4" class="_2FBwK8pA" autoplay="" preload="preload" loop=""></video> -->
    <video src="https://www.mvg0ia0.life:9152/static/bg_batch-0ac1.mp4" class="_2FBwK8pA" autoplay="" preload="preload" loop=""></video>
    <div class="_2UT0Kf_K">
      <div class="DZfPXDqq">
        <a><img src="/static/image/w_logo1-a238.png" /></a>
      </div>
      <div class="_3BxpfSW8">
        <div class="_35_y_F9O">用户登录</div>
        <ul class="_116pmddr">
          <li class="_22Zr7rGv">
            <input type="text" name="name" placeholder="请输入您的账号名称" value="" />
            <i class="_3pvR4aic _2eMogZtk"></i>
          </li>
          <li class="_22Zr7rGv">
            <input type="password" name="password" placeholder="请输入您的账户密码" value="" />
            <i class="_3pvR4aic FRFKT8zV"></i><span class="_1jV7dX8s eyes" style="display: none"></span>
          </li>
          <li class="MoDMiXI4 _22Zr7rGv">
            <input type="text" name="code" v-model="code" class="" placeholder="验证码" autocomplete="off" value="" />
            <i class="_3pvR4aic hN4cKMwr"></i>
            <div class="_6XG621z9">
              <img :src="`/static/image/yzm/${imgLis[index]}.png`" class="tS_Fkc83" /><img
                @click="changIndex"
                data-analytics="button"
                data-label="登录-获取验证码"
                src="data:image/png;base64,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"
                class="_3c-Nb41d"
              />
            </div>
          </li>
          <li>
            <div @click="loginBtn" class="_349CzCYy xJQe3jRu _3SkQZ6Gu _1MwXuX_N"><span>登 录</span></div>
          </li>
          <li class="_1l4fbM7b"><a @click="goNav('/register')">注册帐号</a><a @click="openKefu">忘记密码?</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      index: 0,
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],

      code: null,
      jumpUrl: null,
      show: false,
    };
  },
  components: {},
  created() {
    let that = this;
    that.changIndex();
  },
  mounted() {
    $("input[name='name']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1v9IcRDR');
      } else {
        $(this).next('._3pvR4aic').addClass('_1v9IcRDR');
      }
    });
    $("input[name='password']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1v9IcRDR');
        $(this).nextAll('.eyes').css('display', 'none');
      } else {
        $(this).next('._3pvR4aic').addClass('_1v9IcRDR');
        $(this).nextAll('.eyes').css('display', 'block');
      }
    });
    $("input[name='code']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '' || v.length < 4) {
        $(this).next('._3pvR4aic').removeClass('_1v9IcRDR');
      } else {
        $(this).next('._3pvR4aic').addClass('_1v9IcRDR');
      }
    });
    // _3pvR4aic   _349CzCYy
    // 监听class  状态 控制 登陆按钮
    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        /************************当DOM元素发送改变时执行的函数体***********************/
        if ($("input[name='code']").next('._3pvR4aic').hasClass('_1v9IcRDR') && $("input[name='password']").next('._3pvR4aic').hasClass('_1v9IcRDR') && $("input[name='name']").next('._3pvR4aic').hasClass('_1v9IcRDR')) {
          $('._349CzCYy').removeClass('_3SkQZ6Gu');
        } else {
          $('._349CzCYy').addClass('_3SkQZ6Gu');
        }
        /*********************函数体结束*****************************/
      });
    });
    /**Element**/
    mutationObserver.observe($('#app')[0], {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
      attributeOldValue: true,
      characterDataOldValue: true,
    });

    //点击小眼睛
    var i = true; //显示开关
    $('.eyes').click(function () {
      if (i) {
        $(this).addClass('_1j8Se6eK');
        $(this).prevAll('input').attr('type', 'text');
        i = false;
      } else {
        $(this).removeClass('_1j8Se6eK');
        $(this).prevAll('input').attr('type', 'password');
        i = true;
      }
    });
  },
  methods: {
    openKefu() {
      let that = this;
      that.showTost('正在链接人工客服');
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.jumpUrl = res.data.url;
        }
      });
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    goNav(url) {
      let that = this;
      this.$router.push({ path: url });
    },
    loginBtn() {
      let that = this;
      if ($('._349CzCYy').hasClass('_3SkQZ6Gu')) {
        that.showTost('请输入内容');

        return;
      } else that.login();
    },
    login() {
      let that = this;
      let info = {
        name: $("input[name='name']").val(),
        password: $("input[name='password']").val(),
      };
      if (!that.code) {
        that.showTost('请输入验证码！');

        return;
      }
      if (that.code.toUpperCase() != that.imgLis[that.index]) {
        that.showTost('验证码错误！');
        that.code = null;
        that.changIndex();
        return;
      }
      that.show = true;
      that.$apiFun.login(info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.showTost(res.message);
          that.show = false;
        }
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.getUserInfo();
        }
      });
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        that.show = false;
        if (res.code !== 200) {
          that.showTost(res.message);
        }
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
          that.goNav('/');
        }
      });
    },
    showTost(title) {
      $('body').append(`
            <div class='ant-message' style='top: 400px;'><span><div class='ant-message-notice'><div class='ant-message-notice-content'>
            <div class='ant-message-custom-content ant-message-info'><span role='img' aria-label='info-circle' class='anticon anticon-info-circle'>
            <svg viewBox='64 64 896 896' focusable='false' data-icon='info-circle' width='1em' height='1em' fill='currentColor' aria-hidden='true'>
            <path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z'></path></svg></span><span>
            ${title}
            </span></div></div></div></span>
            </div>`);
      setTimeout('$(".ant-message").detach()', 2000);
    },
  },
  watch: {
    // 新窗口打开页面，解决浏览器拦截问题
    jumpUrl() {
      if (this.jumpUrl) {
        window.open(this.jumpUrl, '_blank');
      }
      this.jumpUrl = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.fangda {
  animation: _308UEapr 0.5s ease-out;
}
.hover {
  display: none;
}
._3gi7jqcw:hover ._2JoosS9F {
  display: none;
}
._3gi7jqcw:hover .hover {
  display: block;
}
._3gi7jqcw._12ZkQT2g ._2JoosS9F {
  display: none;
}
._3gi7jqcw._12ZkQT2g .hover {
  display: block;
}
.ant-tabs-nav .ant-tabs-tab {
  height: 46px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue